<template>
  <div class="container">
    <div class="find-box">
      <h1>{{ $t('roomFinder.title').toUpperCase() }}</h1>
      <form :class="{'finder-grid' : isBusiness, 'finder-no-business' : !isBusiness }" class="shortfind formsearch"
            method="post" v-on:submit.prevent>
        <div class="finder-11">
          <div class="place error fields">
            <svg id="Capa_1" style="enable-background:new 0 0 255.856 255.856;" version="1.1" viewBox="0 0 255.856 255.856"
                 x="0px" xml:space="preserve"
                 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" y="0px">
            <path d="M127.928,38.8c-30.75,0-55.768,25.017-55.768,55.767s25.018,55.767,55.768,55.767
              s55.768-25.017,55.768-55.767S158.678,38.8,127.928,38.8z M127.928,135.333c-22.479,0-40.768-18.288-40.768-40.767
              S105.449,53.8,127.928,53.8s40.768,18.288,40.768,40.767S150.408,135.333,127.928,135.333z" style="fill:#000002;"/>
              <path d="M127.928,0C75.784,0,33.362,42.422,33.362,94.566c0,30.072,25.22,74.875,40.253,98.904
              c9.891,15.809,20.52,30.855,29.928,42.365c15.101,18.474,20.506,20.02,24.386,20.02c3.938,0,9.041-1.547,24.095-20.031
              c9.429-11.579,20.063-26.616,29.944-42.342c15.136-24.088,40.527-68.971,40.527-98.917C222.495,42.422,180.073,0,127.928,0z
               M171.569,181.803c-19.396,31.483-37.203,52.757-43.73,58.188c-6.561-5.264-24.079-26.032-43.746-58.089
              c-22.707-37.015-35.73-68.848-35.73-87.336C48.362,50.693,84.055,15,127.928,15c43.873,0,79.566,35.693,79.566,79.566
              C207.495,112.948,194.4,144.744,171.569,181.803z" style="fill:#000002;"/>
          </svg>
            <div class="custom-select-wrapper">
              <svg id="Capa_1" class="custom-icon" style="enable-background:new 0 0 255.856 255.856;" version="1.1"
                   viewBox="0 0 255.856 255.856" x="0px" xml:space="preserve"
                   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   y="0px">
    <path d="M127.928,38.8c-30.75,0-55.768,25.017-55.768,55.767s25.018,55.767,55.768,55.767
      s55.768-25.017,55.768-55.767S158.678,38.8,127.928,38.8z M127.928,135.333c-22.479,0-40.768-18.288-40.768-40.767
      S105.449,53.8,127.928,53.8s40.768,18.288,40.768,40.767S150.408,135.333,127.928,135.333z" style="fill:#000002;"/>
                <path d="M127.928,0C75.784,0,33.362,42.422,33.362,94.566c0,30.072,25.22,74.875,40.253,98.904
      c9.891,15.809,20.52,30.855,29.928,42.365c15.101,18.474,20.506,20.02,24.386,20.02c3.938,0,9.041-1.547,24.095-20.031
      c9.429-11.579,20.063-26.616,29.944-42.342c15.136-24.088,40.527-68.971,40.527-98.917C222.495,42.422,180.073,0,127.928,0z
      M171.569,181.803c-19.396,31.483-37.203,52.757-43.73,58.188c-6.561-5.264-24.079-26.032-43.746-58.089
      c-22.707-37.015-35.73-68.848-35.73-87.336C48.362,50.693,84.055,15,127.928,15c43.873,0,79.566,35.693,79.566,79.566
      C207.495,112.948,194.4,144.744,171.569,181.803z" style="fill:#000002;"/>
  </svg>

              <select v-model="searchString" class="std-input custom-select">
                <option value="LYON" selected>LYON</option>
                <option value="PÉROUGES">PÉROUGES</option>
                <option value="CHAMBÉRY">CHAMBÉRY</option>
              </select>
            </div>

          </div>
        </div>
        <div class="finder-12">
          <div class="date_in fields v-calendar-input full-width">
            <svg height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m121.693 14.088h-22.429v-7.781a1.75 1.75 0 0 0 -1.75-1.75h-7.462a1.749 1.749 0 0 0 -1.75 1.75v7.781h-18.821v-7.781a1.749 1.749 0 0 0 -1.75-1.75h-7.462a1.749 1.749 0 0 0 -1.75 1.75v7.781h-18.819v-7.781a1.749 1.749 0 0 0 -1.75-1.75h-7.464a1.75 1.75 0 0 0 -1.75 1.75v7.781h-22.429a1.749 1.749 0 0 0 -1.75 1.75v105.855a1.749 1.749 0 0 0 1.75 1.75h115.386a1.749 1.749 0 0 0 1.75-1.75v-105.855a1.749 1.749 0 0 0 -1.75-1.75zm-29.893-6.031h3.962v15.562h-3.962zm-29.783 0h3.962v15.562h-3.96zm-29.783 0h3.966v15.562h-3.964zm-24.177 9.531h20.679v7.781a1.75 1.75 0 0 0 1.75 1.75h7.462a1.749 1.749 0 0 0 1.75-1.75v-7.781h18.821v7.781a1.749 1.749 0 0 0 1.75 1.75h7.462a1.749 1.749 0 0 0 1.75-1.75v-7.781h18.819v7.781a1.749 1.749 0 0 0 1.75 1.75h7.462a1.75 1.75 0 0 0 1.75-1.75v-7.781h20.679v20.025h-111.884zm0 102.355v-78.83h111.886v78.83z"/>
              <path
                d="m27.66 49.015a8.033 8.033 0 1 0 8.033 8.033 8.041 8.041 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m51.887 49.015a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.538 4.538 0 0 1 -4.533 4.533z"/>
              <path
                d="m76.113 49.015a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m100.34 49.015a8.033 8.033 0 1 0 8.032 8.033 8.041 8.041 0 0 0 -8.032-8.033zm0 12.566a4.533 4.533 0 1 1 4.532-4.533 4.537 4.537 0 0 1 -4.532 4.533z"/>
              <path
                d="m27.66 72.5a8.034 8.034 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.538 4.538 0 0 1 -4.533 4.529z"/>
              <path
                d="m51.887 72.5a8.034 8.034 0 1 0 8.033 8.033 8.043 8.043 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.539 4.539 0 0 1 -4.533 4.529z"/>
              <path
                d="m76.113 72.5a8.034 8.034 0 1 0 8.033 8.033 8.043 8.043 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.538 4.538 0 0 1 -4.533 4.529z"/>
              <path
                d="m100.34 72.5a8.034 8.034 0 1 0 8.032 8.033 8.042 8.042 0 0 0 -8.032-8.033zm0 12.567a4.534 4.534 0 1 1 4.532-4.534 4.538 4.538 0 0 1 -4.532 4.529z"/>
              <path
                d="m27.66 95.976a8.033 8.033 0 1 0 8.033 8.033 8.041 8.041 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m51.887 95.976a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.538 4.538 0 0 1 -4.533 4.533z"/>
              <path
                d="m76.113 95.976a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m100.34 95.976a8.033 8.033 0 1 0 8.032 8.033 8.041 8.041 0 0 0 -8.032-8.033zm0 12.566a4.533 4.533 0 1 1 4.532-4.533 4.537 4.537 0 0 1 -4.532 4.533z"/>
            </svg>
            <v-date-picker
              v-model="startDate"
              :color="'orange'"
              :cols="1"
              :input-props="{name: 'date_in', readonly: true, style: 'cursor: pointer;', placeholder: $t('v2.date-picker.placeholder_start')}"
              :locale="$store.state.lang.currentLang"
              :masks="{input: $t('v2.date-picker.format_start')}"
              :min-date="minDateStart"
              :mode="'single'"
              title-position="left"
            />
          </div>
        </div>
        <div class="finder-13">
          <div class="date_in fields v-calendar-input full-width">
            <svg height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m121.693 14.088h-22.429v-7.781a1.75 1.75 0 0 0 -1.75-1.75h-7.462a1.749 1.749 0 0 0 -1.75 1.75v7.781h-18.821v-7.781a1.749 1.749 0 0 0 -1.75-1.75h-7.462a1.749 1.749 0 0 0 -1.75 1.75v7.781h-18.819v-7.781a1.749 1.749 0 0 0 -1.75-1.75h-7.464a1.75 1.75 0 0 0 -1.75 1.75v7.781h-22.429a1.749 1.749 0 0 0 -1.75 1.75v105.855a1.749 1.749 0 0 0 1.75 1.75h115.386a1.749 1.749 0 0 0 1.75-1.75v-105.855a1.749 1.749 0 0 0 -1.75-1.75zm-29.893-6.031h3.962v15.562h-3.962zm-29.783 0h3.962v15.562h-3.96zm-29.783 0h3.966v15.562h-3.964zm-24.177 9.531h20.679v7.781a1.75 1.75 0 0 0 1.75 1.75h7.462a1.749 1.749 0 0 0 1.75-1.75v-7.781h18.821v7.781a1.749 1.749 0 0 0 1.75 1.75h7.462a1.749 1.749 0 0 0 1.75-1.75v-7.781h18.819v7.781a1.749 1.749 0 0 0 1.75 1.75h7.462a1.75 1.75 0 0 0 1.75-1.75v-7.781h20.679v20.025h-111.884zm0 102.355v-78.83h111.886v78.83z"/>
              <path
                d="m27.66 49.015a8.033 8.033 0 1 0 8.033 8.033 8.041 8.041 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m51.887 49.015a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.538 4.538 0 0 1 -4.533 4.533z"/>
              <path
                d="m76.113 49.015a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m100.34 49.015a8.033 8.033 0 1 0 8.032 8.033 8.041 8.041 0 0 0 -8.032-8.033zm0 12.566a4.533 4.533 0 1 1 4.532-4.533 4.537 4.537 0 0 1 -4.532 4.533z"/>
              <path
                d="m27.66 72.5a8.034 8.034 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.538 4.538 0 0 1 -4.533 4.529z"/>
              <path
                d="m51.887 72.5a8.034 8.034 0 1 0 8.033 8.033 8.043 8.043 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.539 4.539 0 0 1 -4.533 4.529z"/>
              <path
                d="m76.113 72.5a8.034 8.034 0 1 0 8.033 8.033 8.043 8.043 0 0 0 -8.033-8.033zm0 12.567a4.534 4.534 0 1 1 4.533-4.534 4.538 4.538 0 0 1 -4.533 4.529z"/>
              <path
                d="m100.34 72.5a8.034 8.034 0 1 0 8.032 8.033 8.042 8.042 0 0 0 -8.032-8.033zm0 12.567a4.534 4.534 0 1 1 4.532-4.534 4.538 4.538 0 0 1 -4.532 4.529z"/>
              <path
                d="m27.66 95.976a8.033 8.033 0 1 0 8.033 8.033 8.041 8.041 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m51.887 95.976a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.538 4.538 0 0 1 -4.533 4.533z"/>
              <path
                d="m76.113 95.976a8.033 8.033 0 1 0 8.033 8.033 8.042 8.042 0 0 0 -8.033-8.033zm0 12.566a4.533 4.533 0 1 1 4.533-4.533 4.537 4.537 0 0 1 -4.533 4.533z"/>
              <path
                d="m100.34 95.976a8.033 8.033 0 1 0 8.032 8.033 8.041 8.041 0 0 0 -8.032-8.033zm0 12.566a4.533 4.533 0 1 1 4.532-4.533 4.537 4.537 0 0 1 -4.532 4.533z"/>
            </svg>
            <v-date-picker
              v-model="endDate"
              :color="'orange'"
              :input-props="{name: 'date_out', readonly: true, style: 'cursor: pointer;', placeholder: $t('v2.date-picker.placeholder_end')}"
              :locale="$store.state.lang.currentLang"
              :masks="{input: $t('v2.date-picker.format_end')}"
              :min-date="minDateEnd"
              :mode="'single'"
              title-position="left"
            />
          </div>
        </div>
        <div class="finder-21">
          <div class="fields">
            <traveler-picker v-model="traveler"
                             :default-adults="traveler.adults"
                             :default-babies="traveler.babies"
                             :default-children="traveler.children"
                             :icon="'/static/img/man-avatar.svg'"
                             :title="$t('roomFinder.guestCount').toUpperCase()"
            />
          </div>
        </div>
        <div class="finder-22">
          <div class="fields">
            <equipment-picker v-model="equipments"
                              :icon="'/static/img/sliders-h-light.svg'"
                              :title="$t('roomFinder.equipments').toUpperCase()"
            />
          </div>
        </div>
        <div class="finder-23">
          <div class="fields">
            <input :value="$t('roomFinder.inputSearch')" class="btn-std" name="" type="submit" @click="searchRoom">
          </div>
        </div>
        <div v-if="!isAuth" class="finder-31">
          <div v-model="isBusiness" class="fields">
            <checkbox-input :label="$t('roomFinder.business').toUpperCase()" :value="isPrivilege"
                            v-on:input="handleBusinessChange"/>
          </div>
        </div>
        <div v-if="!isAuth" class="finder-32">
          <div class="fields businessNumber">
            {{ $t('roomFinder.businessNumber').toUpperCase() }}
            <br>
            {{ $t('topbar.info.phone') }}
          </div>
        </div>

      </form>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import moment from 'moment';
import loader from '../../components/loader.component';
import NumberInput from "../../components/number-input";
import CheckboxInput from "../../components/checkbox-input";
import BusinessCodeInput from "../../components/business-code-input";
import NumberInputBool from "../../components/number-input-bool";
import {MIN_DATE_MOMENT} from "../../stores/pre-fetch-room.store";
import {CAN_BOOK_DAY_USE} from "../../common";
import TravelerPicker from "../../components/traveler-picker";
import EquipmentPicker from "../../components/equipment-picker";

export default {
  name: 'finder-form',
  components: {
    EquipmentPicker,
    TravelerPicker,
    NumberInputBool,
    loader,
    NumberInput,
    CheckboxInput,
    BusinessCodeInput
  },
  data() {
    return {
      startDate: this.$store.state.search.search.start,
      endDate: this.$store.state.search.search.end,
      searchString: this.$store.state.search.search.query,
      traveler: {
        adults: this.$store.state.search.search.travelers.adults,
        children: this.$store.state.search.search.travelers.children,
        babies: this.$store.state.search.search.travelers.babies
      },
      equipments: this.$store.state.search.search.equipments,
      isBusiness: this.$store.state.search.search.isBusiness,
      businessCode: this.$store.state.search.search.businessCode,
      minDateStart: MIN_DATE_MOMENT.toDate(),
      lang: this.$store.state.lang.currentLang,
      blinking: false,
      isWatchingStore: false
    };
  },
  computed: {
    minDateEnd() {
      return moment(this.startDate).add(CAN_BOOK_DAY_USE ? 0 : 1, 'd').toDate();
    },
    ...mapState({
      isRequesting: state => state.preFetchRoom.loading,
      isPrivilege: s => s.client.client.type === 'privilege'
    }),
    isAuth() {
      return this.$store.getters.isAuth;
    }
  },
  mounted() {
    window.addEventListener('app:app-form:open-start-date', this.handleAppForm)
  },
  beforeDestroy() {
    window.removeEventListener('app:app-form:open-start-date', this.handleAppForm)
  },
  watch: {
    startDate(value, oldValue) {
      if (oldValue === null && this.endDate === null) {
        this.endDate = moment(value).add(1, 'd').toDate();
        return;
      }
      const dayDiff = moment(this.endDate).diff(moment(oldValue), 'd');
      this.endDate = moment(value).add(dayDiff, 'd').toDate();
    },
    isBusiness(value) {
      if (value) {
        this.initLoginWatcher();
      }
    }
  },
  methods: {
    handleBusinessChange(e) {
      this.isBusiness = e;
    },
    handleAppForm() {
      this.blinking = true;
      setTimeout(() => {
        this.blinking = false;
      }, 1000);
    },
    initLoginWatcher() {
      if (this.isWatchingStore) return;
      this.isWatchingStore = true;
      const unwatch = this.$store.watch((state, getters) => {
        return state.loginModal.openState;
      }, (value) => {
        if (value === false) {
          this.isBusiness = false;
          this.isWatchingStore = false;
          unwatch();
        }
      });
      this.$store.commit('loginModal/OPEN');
    },
    async searchRoom() {
      this.$store.commit('search/SET_SEARCH_STRING', this.searchString);
      this.$store.commit('search/SET_SEARCH_EQUIPMENTS', this.equipments);
      this.$store.commit('search/SET_SEARCH_START_DATE', this.startDate);
      this.$store.commit('search/SET_SEARCH_END_DATE', this.endDate);
      this.$store.commit('search/SET_SEARCH_TRAVELERS', this.traveler);
      this.$store.commit('search/SET_SEARCH_BUSINESS', this.businessCode);

      await this.$router.push({name: 'search'});
    },
  }
}
</script>

<style scoped>
.error {
  margin-bottom: 0;
}

.custom-select-wrapper {
  position: relative;
  width: 90%;
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 8px;
  background: white;
}

.custom-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.custom-select {
  border: none;
  background: transparent;
  font-size: 16px;
  width: 100%;
  color: black; /* Plus de rouge */
  cursor: pointer;
}

.custom-select:focus {
  outline: none;
}

</style>



// WEBPACK FOOTER //
// src/pages/home/finder-form.vue